import React from 'react';
import PropTypes from 'prop-types';
import { Field, useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { FormInput } from '@luigiclaudio/ga-baseline-ui/form';
import ColorEntryItem from './ColorEntryItem';
import InputsContainer from './InputsContainer';
import InputContainer from './InputContainer';
import TooltipColorPicker from '../TooltipColorPicker';
import Title from '../ColorEntry/Title';
import ColorEntryContainer from './ColorEntryVariant/ColorEntryContainer';
import ColorEntryVariant from './ColorEntryVariant';

const ColorEntryInput = ({ name, showColorPicker, showColorVariant }) => {
    const intl = useIntl();
    const { setFieldValue } = useFormikContext();

    return (
        <ColorEntryContainer>
            <ColorEntryItem>
                <Title title={intl.formatMessage({ id: 'color.inputField.label' })} />
                <InputsContainer>
                    <InputContainer>
                        <Field
                            component={FormInput}
                            id={name}
                            label={intl.formatMessage({ id: 'hex.inputField.label' })}
                            name={name}
                            type="text"
                            prependAddon="#"
                            size="6"
                            autoCorrect="false"
                            spellCheck="false"
                            onChange={(v) => {
                                if (v.target.value.startsWith('#')) {
                                    return setFieldValue(name, v.target.value.slice(1, 7));
                                }
                                return setFieldValue(name, v.target.value.slice(0, 6));
                            }}
                        />
                    </InputContainer>
                    <TooltipColorPicker name={name} show={showColorPicker} />
                </InputsContainer>
            </ColorEntryItem>
            <ColorEntryVariant name={name} show={showColorVariant} />
        </ColorEntryContainer>
    );
};

ColorEntryInput.propTypes = {
    name: PropTypes.string.isRequired,
    showColorPicker: PropTypes.bool,
    showColorVariant: PropTypes.bool,
};

ColorEntryInput.defaultProps = {
    showColorPicker: true,
    showColorVariant: false,
};

export default ColorEntryInput;
